import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IAppSlide } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { MappingService } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-add-app-slide',
  templateUrl: './add-app-slide.component.html',
  styleUrls: ['./add-app-slide.component.scss']
})
export class AddAppSlideComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('coverFile', {static:false}) coverFile: ElementRef;

  TITLE = `Add new slide`

  form: FormGroup;
  section: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  START_UPLOAD: boolean;
  SELECTED_COVER_FILE: any;
  ITEM: IAppSlide;
  uploadPercentCover: any;
  SECTION_LIST: any;

  constructor(
    public dialogRef: MatDialogRef<AddAppSlideComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService
  ) { }


  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async uploadFileCover(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_COVER_FILE = event.target.files[0];
      if (this.ITEM) {
        if (this.SELECTED_COVER_FILE) {
          this.START_UPLOAD = true;
          const file: any = this.SELECTED_COVER_FILE;
          const soundPath = `app_center/${this.ITEM.key}/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercentCover = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          this.ITEM.fileDetail = files;
          this.START_UPLOAD = false;
        }
        this.store.updateCoverDownload(this.data.COLLECTION, this.ITEM, this.ITEM.fileDetail, (success, res) => {
          this.snackBar.open("Cover has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.SELECTED_COVER_FILE = null
        })
      }
    }
  }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      featureStatus: [null, Validators.required],
      description: [null],
      section: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      sourceReading:[null],
    })
    this.section = this.form.controls['section'];

    const { ITEM, TITLE } = this.data;
    this.TITLE = `Add new ${TITLE}`
    this.ITEM = ITEM;

    const SECTION_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_SECTIONS, "name");
    this.SECTION_LIST = MappingService.autoComplete(this.section, SECTION_LIST, "name");
    if (ITEM) {
      this.TITLE = `Edit ${TITLE}`
      const { name, description, featureStatus, sectionKey,sourceReading } = ITEM;
      const selectedSection = SECTION_LIST.filter(m => m.key === sectionKey)[0]
      this.form.patchValue({
        name, description, featureStatus, section: selectedSection,sourceReading
      })
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { name, description, featureStatus, section,sourceReading } = f;
      const registerStatus = STATUS_OBJECT.submitted;

      const item: IAppSlide = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`.trim()),
        organizationRef: null,
        organizationKey: null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: `${name}`.trim() || null,
        description: description || null,
        fileDetail: ITEM ? ITEM.fileDetail : null,
        featureStatus,
        sectionKey: section.key,
        sectionRef: this.ds.firestoreRef().collection(COLLECTION_NAME.BOOK_STORE_SECTIONS).doc(section.key).ref,
        sourceReading:sourceReading||false,
      }

      if (this.SELECTED_COVER_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_COVER_FILE;
        const soundPath = `app_center/${item.key}/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercentCover = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.fileDetail = files;
        this.START_UPLOAD = false;
      }

      this.store.addNewItem(this.data.COLLECTION, item, (success, res) => {
        if (success) {
          this.store.fetchData(this.data.COLLECTION, registerStatus.key)
          this.snackBar.open(`${this.data.TITLE} has been created successful.`, "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        this.coverFile.nativeElement.value = "";
        this.SELECTED_COVER_FILE = null;
        if (!isNew) {
          this.dialogRef.close('yes');
        }
      })
    }
  }
}
